<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="showAll" class="input-error">
    <ul v-if="errors[propName]">
      <li v-for="(val, j) in errors[propName]" :key="j">
        {{
          $t("errors.input.message." + val.replace(/\s+/g, ""), {
            key: $t("label." + propName),
          })
        }}
      </li>
    </ul>
  </div>
  <div v-else class="input-error">
    <ul v-if="errors[propName]">
      <li
        v-html="
          $t(
            'errors.input.message.' + errors[propName][0].replace(/\s+/g, ''),
            { key: $t('label.' + propName) }
          )
        "
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "InputError",
  props: {
    errors: {
      type: Object,
      default: function () {
        return {};
      },
    },
    propName: { type: String, default: "" },
    showAll: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.input-error {
  width: 100%;
  color: $danger;
  margin-bottom: 10px;
}
</style>
